export default {
  name: "SidebarUserFooter",

  props: {
    initials: {
      type: String,
      required: true
    },
    full_name: {
      type: String,
      required: true
    }
  }
};
